export default {
  ALLIANZ_RECURRING_CONTRIBUTIONS_REPOSITORY: Symbol.for('ALLIANZ_RECURRING_CONTRIBUTIONS_REPOSITORY'),
  ALLIANZ_RECURRING_CONTRIBUTIONS_STATE_MANAGER: Symbol.for('ALLIANZ_RECURRING_CONTRIBUTIONS_STATE_MANAGER'),
  SET_RECURRING_CONTRIBUTIONS_STATE_MANAGER: Symbol.for('SET_RECURRING_CONTRIBUTIONS_STATE_MANAGER'),
  GET_ALLIANZ_RECURRING_CONTRIBUTIONS_QUERY: Symbol.for('GET_ALLIANZ_RECURRING_CONTRIBUTIONS_QUERY'),
  UPDATE_ALLIANZ_RECURRING_CONTRIBUTIONS_COMMAND: Symbol.for('UPDATE_ALLIANZ_RECURRING_CONTRIBUTIONS_COMMAND'),
  SUSPEND_ALLIANZ_RECURRING_CONTRIBUTIONS_COMMAND: Symbol.for('SUSPEND_ALLIANZ_RECURRING_CONTRIBUTIONS_COMMAND'),
  MONTHLY_COLLECTION_DAYS_SERVICE: Symbol.for('MONTHLY_COLLECTION_DAYS_SERVICE'),
};
